import { render } from "./DateInput.vue?vue&type=template&id=f96cfbf6"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hr.tomorrow.services/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__